import { atom } from "jotai";
import { userAtom } from "./user.atoms";
import { UserRepository } from "@/infrastructure/repositories/user";
import { AuthRepository } from "@/infrastructure/repositories/auth";
import { GetUserBrandsUseCase, GetUserUseCase } from "@/core/usecases/user";
import { LoggerManager } from "@/infrastructure/services/logger";

export const setUserAtom = atom(null, async (_get, set) => {
  const loadUser = async () => {
    try {
      const userRepository = new UserRepository(new AuthRepository());
      const getUser = new GetUserUseCase(userRepository);
      const getUserBrands = new GetUserBrandsUseCase(userRepository);
      const user = await getUser.execute();
      const userBrands = await getUserBrands.execute();

      set(userAtom, {
        user,
        userBrands,
        isLoading: false,
        error: null,
      });
      if (user && userBrands) {
        if (!LoggerManager.isInitialized) {
          LoggerManager.initializeHighlight();
        }
        LoggerManager.setIdentity({
          email: user.email,
          name: user.fullName,
        });
      }
    } catch (error) {
      set(userAtom, {
        user: null,
        userBrands: null,
        isLoading: false,
        error: error instanceof Error ? error : new Error("An unknown error occurred"),
      });
    }
  };
  loadUser();
});
